import { useState, useEffect } from 'react'
import { supabaseGetter } from '~/api/supabase-getter'

/**
 * Fetch variety templates (children) for a given species template.
 * Returns full template records sorted by name.
 */
export const useCropVarieties = ({ speciesId }) => {
  const [varieties, setVarieties] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!speciesId) {
      setVarieties([])
      setLoading(false)
      setError(null)
      return
    }

    async function fetchData() {
      setLoading(true)
      setError(null)

      try {
        const { data, error: fetchError } = await supabaseGetter.cropTemplates.getByParent(speciesId)
        if (fetchError) throw fetchError
        setVarieties(data || [])
      } catch (err) {
        console.error('Error fetching crop varieties:', err)
        setError(err.message)
        setVarieties([])
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [speciesId])

  return { varieties, loading, error }
}
